import { supabase } from './supabaseClient';

/** Droits Contact et SAV du site, réglables par rôle (menu_permissions) et par utilisateur (exceptions). */
export type FeatureKey = 'contact_messages' | 'sav_requests';

export const FEATURE_KEYS: FeatureKey[] = ['contact_messages', 'sav_requests'];

export const FEATURE_LABELS: Record<FeatureKey, string> = {
  contact_messages: 'Messages Contact',
  sav_requests: 'SAV du site',
};

export interface FeatureOverrideRow {
  auth_user_id: string;
  email: string;
  nom: string | null;
  prenom: string | null;
  role_name: string;
  feature: FeatureKey;
  role_allowed: boolean;
  override_allowed: boolean | null;
  effective: boolean;
  set_by_email: string | null;
  set_at: string | null;
}

export const featureAccessService = {
  /** Droits effectifs de l'utilisateur connecté (rôle + exception). Lève en cas d'erreur. */
  async getMyFeatures(): Promise<Partial<Record<FeatureKey, boolean>>> {
    const { data, error } = await supabase.rpc('get_my_features');
    if (error) throw error;
    const result: Partial<Record<FeatureKey, boolean>> = {};
    for (const row of (data ?? []) as { feature: string; allowed: boolean }[]) {
      if ((FEATURE_KEYS as string[]).includes(row.feature)) {
        result[row.feature as FeatureKey] = row.allowed === true;
      }
    }
    return result;
  },

  /** Super admin uniquement : un utilisateur × un droit, avec rôle, exception et état effectif. */
  async listOverrides(): Promise<FeatureOverrideRow[]> {
    const { data, error } = await supabase.rpc('list_feature_overrides');
    if (error) throw error;
    return (data ?? []) as FeatureOverrideRow[];
  },

  /** Super admin uniquement. allowed = null : retire l'exception (retour au rôle). Renvoie le droit effectif. */
  async setOverride(
    authUserId: string,
    feature: FeatureKey,
    allowed: boolean | null
  ): Promise<boolean> {
    const { data, error } = await supabase.rpc('set_user_feature_override', {
      p_auth_user_id: authUserId,
      p_feature: feature,
      p_allowed: allowed,
    });
    if (error) throw error;
    return data === true;
  },
};
